import { row } from '@syncfusion/ej2-react-grids';
import http from '../../services/http-common';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import dropdownService from '../software-dynamic-version-6/api.service-v-6'
import moment  from 'moment';
import securityService from '../security/security.service';
import apiService from '../software-dynamic-version-6/api.service-v-6'
import saleInvoiceService from '../sale-invoice/sale-invoice.service';
class ValidationRules {
  constructor(fields) {
    this.rules = {};

    fields.forEach(f => {
      const { field, type, required = false, idKey } = f;

      // base rule
      let rule = { required, type, ...f};

      // if foreign key, attach idKey
      if (type === "fk" && idKey) {
        rule.idKey = idKey;
      }

      this.rules[field] = rule;
    });
  }

  // ✅ Get all rules
  getAllRules() {
    return this.rules;
  }

}

// // === Example Usage ===
// const fields = [
//   { field: "InvoiceTypeID", type: "fk", required: false, idKey: "InvoiceTypeID" },
//   { field: "InvoiceOpeningDate", type: "date", required: false },
//   { field: "ModuleName", type: "fk", required: false, idKey: "ModuleID" },
//   { field: "AccountID", type: "fk", required: false, idKey: "AccountID" },
//   { field: "PaymentDays", type: "number", required: false },
//   { field: "ExcludingTaxAmount", type: "number", required: false },
//   { field: "Remarks", type: "string", required: false }
// ];

class ImportExcelService {
  constructor() {
    this.fieldSets = {
      SaleInvoice:{
        fields: 
        [
          
          /* 1 ==> */ { field: "EntryNo", headerText: 'Entry No', 
          width: '150px', textAlign: 'right', headerTextAlign: 'center',
           required: false, other: [{allowEditing:false}] },
          /* 2 ==> */  { field: "invoiceDate",headerText:'Invoice  Date',width:'130px',textAlign:'left' ,
          headerTextAlign:'center', type: "date", required: false ,other:[{allowEditing:true,editType:'datepickeredit'}]},

          /* 3 ==> */ { field: "invoiceRefNo", headerText: 'invoice Ref No', 
          width: '150px', textAlign: 'right', headerTextAlign: 'center',
           required: false, other: [{allowEditing:false }] },

          /* 4 ==> */ { field: "sellerNTNCNIC", headerText: 'seller NTN CNIC', 
          width: '150px', textAlign: 'right', headerTextAlign: 'center',
           required: false, other: [{  }] },

          /* 5 ==> */ { field: "sellerBusinessName", headerText: 'seller Business Name', 
          width: '150px', textAlign: 'right', headerTextAlign: 'center',
           required: false, other: [{  }] },

          /* 6 ==> */ { field: "sellerProvince", headerText: 'seller Province', 
          width: '150px', textAlign: 'right', headerTextAlign: 'center',
           required: false, other: [{  }] },

            // DD
          /* 7 ==> */ { field: "buyerProvince", headerText: 'buyer Province', 
          width: '150px', textAlign: 'right', headerTextAlign: 'center',
          type: "fk", required: false, idKey: "buyerProvinceCode",  other: [{  }] },

          /* 8 ==> */ { field: "invoiceType",idKey: "invoiceTypeID",headerText:'Invoice Type'
          ,width:'130px',textAlign:'left' ,headerTextAlign:'center', type: "fk",
           required: false ,other:[{allowEditing:false}]},

          /* 9 ==> */ { field: "buyerNTNCNIC",headerText:'buyer NTN / CNIC',width:'140px',
          textAlign:'left' ,headerTextAlign:'center', required: false, 
          other:[]},

          /* 10 ==> */ { field: "buyerBusinessName",headerText:'buyer Business Name',width:'140px',
          textAlign:'left' ,headerTextAlign:'center', required: false, 
          other:[]},

          /* 11 ==> */ { field: "sellerAddress", headerText: 'seller Address', width: '180px',
           textAlign: 'left', headerTextAlign: 'center', required: false, other: [] },

          /* 12 ==> */ { field: "buyerAddress", headerText: 'buyer Address', width: '180px',
           textAlign: 'left', headerTextAlign: 'center', required: false, other: [] },

          /* 13 ==> */ { field: "buyerRegistrationType", headerText: 'buyer Registration Type',
           width: '180px', textAlign: 'left', headerTextAlign: 'center', required: false, other: [] },

          /* 14 ==> */ { field: "scenarioId", headerText: 'scenario Id', width: '180px', textAlign: 'left',
           headerTextAlign: 'center', required: false, other: [] },
          
          /* 14 ==> */ { field: "ChallanNo", headerText: 'REFERENCE NO', width: '180px', textAlign: 'left',
           headerTextAlign: 'center', required: false, other: [] },
          
          // SaleInvoiceID	hS_CODE	productDescription	rate	uoM	quantity	totalValues	valueSalesExcludingST	fixedNotifiedValueOrRetailPrice	salesTaxApplicable	salesTaxWithheldAtSource	extraTax	furtherTax	sroScheduleNo	fedPayable	discount	transactioN_Desc	sroItemSerialNo	SaleInvoiceDetailID	FBRSaleInvoiceDetailNo	HSCodeDetail
          // 4047	5208.1100		18%	Meter	1	1.18	1	0	0.18	0		0		0	0	Goods at standard rate (default)		3038	NULL	-
  // Detail Section Columns
 /* 15 ==> */ { field: "HSCode", headerText: 'HS Code', width: '120px', textAlign: 'left',
   headerTextAlign: 'center', 
   type: "fk", required: false, idKey: "hS_CODE", 
   /*DataSource: { type: 'Route', source: 'hsCodeDropdown' }*/ other: [] },

 /* 16 ==> */ { field: "productDescription", headerText: 'Product Description', 
  width: '180px', textAlign: 'left', headerTextAlign: 'center', required: false, other: [] },

  /* 17 ==> */ { field: "rate", headerText: 'Rate', width: '100px', textAlign: 'right', 
  headerTextAlign: 'center', required:true, other: [{ format: 'n0',edit:{format:'n0'}, editType: 'numericedit' }] },

// dde with param
  /* 18 ==> */ { field: "UOM", headerText: 'UOM', width: '100px', textAlign: 'left',
   headerTextAlign: 'center', type: "fk", required: false, idKey: "uoMValue",
   DataSource:
   {
type: "function",
source: saleInvoiceService.getImportExcelDD, // actual function
entity: "UOMDD",
params: { hS_CODE: "pickauto" }
}
    , other: [] },

  /* 19 ==> */ { field: "quantity", headerText: 'Quantity', width: '100px', textAlign: 'right', 
  headerTextAlign: 'center', type: "number", required: false, other: [{ format: 'n0', edit:{format:'n0'}, editType: 'numericedit', showSum: true }] },

  /* 20 ==> */ { field: "totalValues", headerText: 'Total Values', width: '120px', 
  textAlign: 'right', headerTextAlign: 'center', 
  type: "number", required: false, other: [{ format: 'n0',edit:{format:'n0'}, editType: 'numericedit', showSum: true }] },

  /* 21 ==> */ { field: "valueSalesExcludingST", headerText: 'Sales Value (Excl. ST)',
   width: '160px', textAlign: 'right', headerTextAlign: 'center',
    type: "number", required: false, other: [{ format: 'n0',edit:{format:'n0'}, editType: 'numericedit', showSum: true }] },

  /* 22 ==> */ { field: "fixedNotifiedValueOrRetailPrice", headerText: 'Retail / Notified Value',
   width: '170px', textAlign: 'right', headerTextAlign: 'center', 
   type: "number", required: false, other: [{ format: 'n0',edit:{format:'n0'}, editType: 'numericedit',showSum: true }] },

  /* 23 ==> */ { field: "salesTaxApplicable", headerText: 'Sales Tax Applicable', 
  width: '150px', textAlign: 'right', headerTextAlign: 'center',
   type: "number", required: false, other: [{ format: 'n0',edit:{format:'n0'}, editType: 'numericedit',showSum: true }] },

  /* 24 ==> */ { field: "salesTaxWithheldAtSource", headerText: 'ST Withheld at Source',
   width: '160px', textAlign: 'right', headerTextAlign: 'center', type: "number",
    required: false, other: [{ format: 'n0',edit:{format:'n0'}, editType: 'numericedit' ,showSum: true}] },

  /* 25 ==> */{ field: "extraTax", headerText: 'Extra Tax',
   width: '120px', textAlign: 'left', headerTextAlign: 'center', required: false, other: [] },

  /* 26 ==> */ { field: "furtherTax", headerText: 'Further Tax',
   width: '120px', textAlign: 'right', headerTextAlign: 'center',
    type: "number", required: false, other: [{ format: 'n0',edit:{format:'n0'}, editType: 'numericedit' ,showSum: true}] },

    // dde with param
  { field: "sroScheduleNo", headerText: 'SRO Schedule No', 
  width: '150px', textAlign: 'left', headerTextAlign: 'center',
  type: "fk", required: false, idKey: "sroScheduleNoID", DataSource:
   {
type: "function",
source: saleInvoiceService.getImportExcelDD, // actual function
entity: "sroScheduleNoDD",
params: {  
  rate:"pickauto",
  invoiceDate:"pickauto",
  buyerProvinceCode: "pickauto" }
}, other: [] },

  { field: "fedPayable",
   headerText: 'FED Payable', width: '120px',
    textAlign: 'right', headerTextAlign: 'center', 
    type: "number", required: false, other: [{ format: 'n0' ,edit:{format:'n0'}, editType: 'numericedit',showSum: true}] },

  { field: "discount", headerText: 'Discount'
  , width: '120px', textAlign: 'right', 
  headerTextAlign: 'center', type: "number",
   required: false, other: [{ format: 'n0',edit:{format:'n0'}, editType: 'numericedit',showSum: true }] },

//DD
   { field: "transactioN_Desc",
   headerText: 'Transaction Description',
    width: '180px', 
    textAlign: 'left',
     headerTextAlign: 'center', 
     type: "fk", required: false, idKey: "transactioN_TYPE_ID",other: [] },

      // DDE WITH PARAMS
  { field: "sroItemSerialNo", 
  headerText: 'SRO Item Serial No',
   width: '150px', textAlign: 'left',
    headerTextAlign: 'center', 
    type: "fk", required: false, idKey: "sroItemSerialID", DataSource:
   {
type: "function",
source: saleInvoiceService.getImportExcelDD, // actual function
entity: "sroItemSerialNoDD",
params: {  
  sroScheduleNoID:"pickauto",
  invoiceDate:"pickauto"}
},other: [] }
]
,
      dropDownSources: { 
        invoiceType:[
          { id: 1, value: "Purchase Invoice" },
          { id: 2, value: "Sale Invoice" }
        ],
        HSCode:[],
        buyerProvince:[],
        transactioN_Desc:[]
      },
      isDropDownSourcesLoaded: false,

    },  
      Customer: [
        { field: "CustomerName", type: "string", required: false },
        { field: "Email", type: "string", required: false },
        { field: "Phone", type: "string", required: false }
      ]
    };
  }
  
  generateColumnRules = (fieldSet) => {
    const rules = new ValidationRules(fieldSet);
    return rules.getAllRules();
  };

  downloadAndReadExcel = async (inputType) => {
    try {
      console.log(inputType);
      console.log(this.fieldSets);
      console.log(this.generateColumnRules(this.fieldSets[inputType].fields));
      let headersObject = Object.keys(this.generateColumnRules(this.fieldSets[inputType].fields)).reduce((acc, key) => {
        acc[key] = "";
        return acc;
      }, {});
      const headers = [headersObject];
      const worksheet = XLSX.utils.json_to_sheet(headers, { skipHeader: false });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `${inputType}_template.xlsx`);
    } catch (error) {
      console.error("Error:", error);
    }
  };



  // =============== PROCESS EXCEL DATA START ======================
  

  // ===============  check uploaded file same as template file by header ======================
  fileCheckByHeader =  (headerOfFile,inputType) => { 
    console.log(headerOfFile)
    let headersObject = Object.keys(this.generateColumnRules(this.fieldSets[inputType].fields)).map(key => key.toLowerCase())
    if(headersObject.length != headerOfFile.length) return false;
      console.log(headersObject)
  headerOfFile.forEach(element => {
    if(!headersObject.includes(element.toLowerCase())) return false;
  });
  return true;
    
  };

  // ===============  extract data of uploaded execl file ======================

   cleanExcelData(data) {
    return data.map(row => {
      const cleanField = (value) => {
        if (typeof value === "string" &&
            value.startsWith('"') &&
            value.endsWith('"')) 
        {
          return value.substring(1, value.length - 1); // remove first and last quote
        }
        return String(value ?? ""); // always return string
      };
      const formatTwoDecimalsRoundUp = (value) => {
        if (value == null || value === "") return 0;
      
        // remove commas or unwanted characters
        let num = parseFloat(String(value).replace(/,/g, ""));
      
        if (isNaN(num)) return 0;
      
        // round UP to 2 decimals
        num = Math.ceil(num * 100) / 100;
      
        // always return 2 decimals
        return num.toFixed(2);
      };
      
      return {
        ...row,
  
        // clean only required fields
        quantity:formatTwoDecimalsRoundUp(row.quantity),
        salesTaxApplicable:formatTwoDecimalsRoundUp(row.salesTaxApplicable),
        totalValues:formatTwoDecimalsRoundUp(row.totalValues),
        valueSalesExcludingST:formatTwoDecimalsRoundUp(row.valueSalesExcludingST),
        HSCode: cleanField(row.HSCode),
        buyerNTNCNIC: cleanField(row.buyerNTNCNIC),
        sellerNTNCNIC: cleanField(row.sellerNTNCNIC)
      };
    });
  }
  readXlsxFile = async (file,inputType) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload =  (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Get first worksheet
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];

        // Convert to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (jsonData.length > 0) {
          const headers = jsonData[0];
          let fileCheckByHeader =  this.fileCheckByHeader(headers,inputType);
          if(!fileCheckByHeader) {
              resolve({ status: false, error: "PLease Upload Correct File"})
          }

          let rows = jsonData.slice(1);
            
            if (rows.length === 1) {
              const firstRow = rows[0];
              const values = Object.values(firstRow); // get all column values

              const isAllEmpty = values.every(
                (val) => val === null || val === '' || val === undefined
              );

              if (isAllEmpty) {
                rows = [];
              }
            }

          // const formattedData = rows.map((row) => {
          //   const obj = {};
          //   headers.forEach((header, index) => {
          //     obj[header] = row[index] || "";
          //   });
          //   return obj;
          // });

          const formattedData = rows.map((row,ind) => {
            console.log(row)
  const obj = {};
  headers.forEach((header, index) => {
    // let cellValue = row[index] || "";
 let cellValue = row[index] ?? "";



    // Check if the header is a date column (you can customize this check)
    if (header.toLowerCase().includes("date") && typeof cellValue === "number") {
      // Convert Excel serial date to JS Date
      const date = new Date(Math.round((cellValue - 25569) * 86400 * 1000));
      cellValue = date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    }

    obj[header] = cellValue;
  });
  return {ExcelRowID:ind + 2,...obj};
});

          console.log("formattedData", formattedData);
          
const cleaned = this.cleanExcelData(formattedData);
console.log(cleaned);
          resolve({
            data: cleaned,
            fileName: file.name,
            headers: headers,
          });
        } else {
          resolve({ data: [], fileName: file.name, headers: [] });
        }
      } catch (error) {
        reject({ error: error.message, data: [] });
      }
    };

    reader.onerror = () => reject({ error: "File read error", data: [] });
  });
};




// ============= get dropdown data according input or execel data =============
pushDropDownSourceByInputType = (inputType, DropDownData) =>{
  
  console.log(DropDownData)
  const fieldSet = this.fieldSets[inputType];
  fieldSet.dropDownSources = {...fieldSet.dropDownSources,...DropDownData};
}
updateDropDownDataByType = (inputType , inputFieldType , DropDownData) =>{
  console.log(inputFieldType)
  console.log(DropDownData)
  const fieldSet = this.fieldSets[inputType];
  fieldSet.dropDownSources[inputFieldType] = DropDownData
}

getDropdownData = async (inputType) => {
  const fieldSet = this.fieldSets[inputType];

  // If already loaded, just return the stored dropdown sources
  if (fieldSet?.isDropDownSourcesLoaded) {
    return fieldSet.dropDownSources;
  }

  // Otherwise, fetch all dropdown sources
  const promises = fieldSet?.fields
    .filter(row => row.type === "fk" && row.DataSource && row.DataSource.type === "Route")
    .map(row => {
      return dropdownService.getAllForList(row.DataSource.source)
        .then(res => ({
          [row.field]: res?.data?.recordset || []   // store field name as key
        }));
    });

  // Wait for all dropdowns to load
  const results = await Promise.all(promises);
    console.log(results)
  // Merge results into one object
  const dropDownSources = results.reduce((acc, cur) => ({ ...acc, ...cur }), {});
    console.log(dropDownSources)
    console.log({...fieldSet.dropDownSources,...dropDownSources})
  // Cache the result
  fieldSet.dropDownSources = {...fieldSet.dropDownSources,...dropDownSources};
  fieldSet.isDropDownSourcesLoaded = true;

  return dropDownSources;
};



getTableList =  (dataList,inputType) => {
  console.log(dataList)
  return new Promise((resolve, reject) => { 
  
  let datalistType = dataList?.dataSource?.type || ''
  let datalistSource = dataList?.dataSource?.source
  if(datalistType != '' && datalistType.toLowerCase() == "function"){

  datalistSource().then(res => { 
    resolve(res.data.recordset); 
  }).catch(err => { 
    reject(err); 
  });
  
  }else if( datalistType != '' &&  datalistType.toLowerCase() == "Route"){
    dropdownService.getAllForList(datalistSource).then(res => { 
    resolve(res.data.recordset); 
  }).catch(err => { 
    reject(err); 
  });

  }else{
  dropdownService.getAllForList(inputType).then(res => { 
    resolve(res.data.recordset); 
  }).catch(err => { 
    reject(err); 
  });

  }
});
};


// rules ===  rule is object where key is column name and value is validation rule
// newExcelData ====  this is array of objects where each object is row of excel data
// dropdowns ===  this is nested object containing arrays of objects where each object is dropdown data
// tableData ==== table data of main table which use in check duplicate  
// checkDuplicate ==== columns in array  [["ProductName", "Age"]], 
// checkDuplicate ==== type of check duplicate mode
          // Mode: "individual" → only single columns
          // Mode: "combination" → only combinations

ValidateDataAccordingRules = async (excelData, inputType,dataList,duplicateType,duplicateColumns) => { 
    try { 
    console.log(excelData);
    console.log(inputType);
let rules = this.generateColumnRules(this.fieldSets[inputType].fields);
let newExcelData = excelData;
// let dropdowns = await this.getDropdownData(inputType);
// let tableData = await this.getTableList(dataList,inputType)
let dropdowns = {}
let tableData = []
      console.log(tableData)

// let fetchExcelValidateData = await this.validateData(rules, newExcelData, dropdowns, tableData, duplicateColumns,duplicateType,inputType)
// console.log(fetchExcelValidateData);
let fetchExcelValidateData = await this.simpleValidateData(rules, newExcelData, dropdowns, tableData, duplicateColumns,duplicateType,inputType)
console.log(fetchExcelValidateData);

let praparedData = {
  data:fetchExcelValidateData,
  // data:excelData,
  inputType:inputType,
  columns:
  [
   { field: "ExcelRowID",headerText:'Excel Row ID',width:'150',textAlign:'left' ,headerTextAlign:'center', other:[{allowEditing:false}]},
  ,...this.fieldSets[inputType].fields
  ].filter(f => f && typeof f === "object")

}
return praparedData
    } catch (error) {
      console.error("Error:", error);
    }
  };
  
  
   simpleValidateData(
    rules,
    newExcelData,
    dropdowns,
    tableData,
    duplicateColumns,
    duplicateType,
    inputType
  ) {
  
    const results = [];
  
    for (let index = 0; index < newExcelData.length; index++) {
      const row = newExcelData[index];
      let errors = {};
  
      // ----------------------------------------------------
      // LOOP OVER RULE KEYS (same as your example)
      // ----------------------------------------------------
      for (let key in rules) {
        const rule = rules[key];
        const value = row[key];
        console.log(rule,value)
        // Required check
        if (rule.required && (value === "" || value === null || value === undefined)) {
          errors[key] = `"${key}" is required but missing/empty`;
          continue;
        }
      }
  
      // ----------------------------------------------------
      // CREATE FINAL ROW OUTPUT
      // ----------------------------------------------------
      results.push({
        // rowIndex: index,
        validateRow: false,
        ValidateBtnDisable:false,
        FBRError: {},
        hasFBRError:false,
        FBRValidObject:{},
        tableObject:{},
        ...row,
  
        hasBasicError: Object.keys(errors).length > 0,
        errors
      });
    }
  
    return results;
  }
  
  
  // =============== PROCESS DATA START======================
 



  validateData = async (rules, newData, dropdowns, tableData, uniqueCombinations = [], mode = "with", inputType) => {
    let results = [];
  
  
    // keep this at outer scope (shared cache across calls)
  const dynamicCache = {}; // { cacheKey: data }
  
  /**
   * fetchDynamicData(fieldConfig, row, dropdowns)
   * - fieldConfig: rule config for the field whose DataSource needs calling
   * - row: current row object (to read pickauto values)
   * - dropdowns: existing cached dropdown lists (object keyed by field)
   *
   * NOTES:
   * - This function does NOT recursively call itself to resolve FK params.
   * - If a param uses "pickauto" and dropdowns has a list for that param key,
   *   we try to find an id from that list. Otherwise we fall back to row value or default.
   */
  const fetchDynamicData = async (fieldConfig, row = {}, dropdowns = {}) => {
    try {
      const ds = fieldConfig?.DataSource || {};
      if (ds.type !== "function" || !ds.source) return [];
  
      // determine callable source and entity
      const entityName = ds.entity || (typeof ds.source === "string" ? ds.source : "UnknownEntity");
      const paramsTemplate = ds.params || {};
  
      // Build dynamic params
      const dynamicParams = {};
      for (const paramKey of Object.keys(paramsTemplate)) {
        let paramTemplateValue = paramsTemplate[paramKey];
  
        // support "pickauto" and "pickauto || defaultValue"
        if (typeof paramTemplateValue === "string" && paramTemplateValue.trim().startsWith("pickauto")) {
          // parse default: "pickauto || 0" or "pickauto||0"
          const parts = paramTemplateValue.split("||").map(p => p.trim());
          const defaultVal = parts.length > 1 ? tryParse(parts[1]) : null;
  
          // 1) prefer explicit row value for the same key
          let resolved = getSafe(row, paramKey, null);
  
          // 2) if missing, try to resolve from dropdowns[paramKey] (common FK case)
          if (isBlank(resolved) && dropdowns && dropdowns[paramKey] && Array.isArray(dropdowns[paramKey])) {
            const list = dropdowns[paramKey];
            // attempt to match using a few heuristics:
            // - match item.value against row[paramKey]
            // - match item.value against row[paramKey.replace('ID','')] etc (simple heuristic)
            const candidate = findDropdownMatch(list, row[paramKey], row);
            if (candidate) {
              // prefer id if present, otherwise value
              resolved = candidate.id ?? candidate.value;
            }
          }
  
          // 3) fallback to default if still missing
          if (isBlank(resolved)) resolved = defaultVal;
  
          dynamicParams[paramKey] = resolved;
        } else {
          // static value (non-pickauto) — pass directly
          dynamicParams[paramKey] = paramTemplateValue;
        }
      }
  
      // caching key
      const cacheKey = `${entityName}|${JSON.stringify(dynamicParams)}`;
      if (dynamicCache[cacheKey]) {
        return dynamicCache[cacheKey];
      }
  
      // determine api function to call
      let apiFunc = null;
      if (typeof ds.source === "function") {
        
        apiFunc = ds.source.bind(saleInvoiceService);  // ✅ keep `this`

      } else if (apiService && typeof apiService.getAllForList === "function") {
        apiFunc = apiService.getAllForList;
      }
  
      if (typeof apiFunc !== "function") {
        console.error("Invalid API function for DataSource:", ds);
        return null;
      }
  
      // call API and cache result
      
      console.log(entityName)
      console.log(dynamicParams)
      const result = await apiFunc(entityName, {...dynamicParams,...row});
      dynamicCache[cacheKey] = result;
      return result;
    } catch (err) {
      console.error("Error in fetchDynamicData:", err);
      return null;
    }
  
    // ---------- helper functions (local) ----------
    function isBlank(v) {
      return v === undefined || v === null || (typeof v === "string" && v.trim() === "");
    }
  
    function getSafe(obj, key, fallback) {
      try {
        return obj && Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : fallback;
      } catch {
        return fallback;
      }
    }
  
    // attempt to match a dropdown list to a row value with simple heuristics
    function findDropdownMatch(list, primaryRowValue, rowObj) {
      // normalize helper
      const norm = x => (x === undefined || x === null ? "" : String(x).trim().toLowerCase());
  
      const prefer = norm(primaryRowValue);
      // first attempt: match against provided primaryRowValue
      if (prefer) {
        const found = list.find(item => norm(item.value) === prefer || norm(item.display) === prefer);
        if (found) return found;
      }
  
      // second attempt: try other row keys that might relate to the param (basic heuristics)
      // e.g. if paramKey is "CustomerID" and row has "Customer" or "CustomerName"
      // We don't have paramKey here; list-level heuristic only. Return first match where item.value exactly equals row any string fields.
      for (const k of Object.keys(rowObj || {})) {
        const v = norm(rowObj[k]);
        if (!v) continue;
        const found = list.find(item => norm(item.value) === v || norm(item.display) === v);
        if (found) return found;
      }
  
      // last attempt: if list items contain an 'id' and 'value' take the first item as fallback
      if (list.length === 1) return list[0];
  
      return null;
    }
  
    function tryParse(val) {
      // parse numbers, booleans, or keep string
      if (val === undefined || val === null) return null;
      const v = String(val).trim();
      if (v === "") return null;
      if (/^\d+$/.test(v)) return Number(v);
      if (/^(true|false)$/i.test(v)) return v.toLowerCase() === "true";
      // remove quotes if provided '"abc"'
      return v.replace(/^['"]|['"]$/g, "");
    }
  };
  
  // const fetchDynamicData = async (fieldConfig, row) => {
  //   try {
  //     const ds = fieldConfig.DataSource || {};
  //     if (ds.type !== "function" || !ds.source) return null;
  
  //     let source = ds.source;
  
  //     // 🧠 Detect static call form like apiService.getAllForList('Entity', {...})
  //     // Instead of string parsing, inspect the original config
  //     // If source is an object, skip (no need to call)
  //     if (typeof source !== "function" && typeof source !== "object") {
  //       console.warn("Unknown DataSource format for:", fieldConfig.field, source);
  //       return null;
  //     }
  
  //     // Extract entity name and parameters if available
  //     // Since you define it like apiService.getAllForList('InvoiceOpeningAccountDD', { PaymentDays:'pickauto' })
  //     // we must rebuild that call dynamically instead of executing it immediately.
  
  //     // To make this work consistently, store DataSource like below 👇
  //     // DataSource: { type:'function', source: apiService.getAllForList, entity:'InvoiceOpeningAccountDD', params:{ PaymentDays:'pickauto' } }
  
  //     // 🔹 Fix for your current structure (where source = apiService.getAllForList(...))
  //     // We'll re-infer function & params if `source` is not callable
  //     if (typeof source === "object" && !source.then) {
  //       // source is plain object (already executed or empty)
  //       // So we can’t extract info — fix: read from DataSource again
  //       if (!ds.entity && !ds.params) {
  //         console.error("⚠️ Invalid DataSource configuration. Use 'entity' and 'params' keys for dynamic calls.");
  //         return null;
  //       }
  //     }
  
  //     // Build dynamic parameters
  //     const entityName = ds.entity || "UnknownEntity";
  //     const paramsTemplate = ds.params || {};
  //     let dynamicParams = {};
  
  //     for (let key in paramsTemplate) {
  //       const val = paramsTemplate[key];
  //       if (val === "pickauto") {
  //         dynamicParams[key] = row[key] ?? null;
  //       } else {
  //         dynamicParams[key] = val;
  //       }
  //     }
  
  //     const cacheKey = `${entityName}|${JSON.stringify(dynamicParams)}`;
  //     if (dynamicCache[cacheKey]) {
  //       // console.log("✅ Using cached data for:", cacheKey);
  //       return dynamicCache[cacheKey];
  //     }
  
  //     // Determine callable
  //     let apiFunc = null;
  
  //     // Case 1: new recommended structure
  //     if (typeof ds.source === "function") {
  //       apiFunc = ds.source;
  //     }
  
  //     // Case 2: old structure, but you can fix it easily (see below example)
  //     if (!apiFunc && apiService?.getAllForList) {
  //       apiFunc = apiService.getAllForList;
  //     }
  
  //     if (typeof apiFunc !== "function") {
  //       console.error("❌ Invalid api function for:", entityName);
  //       return null;
  //     }
  
  //     // 🚀 Call API and cache result
  //     console.log(entityName, dynamicParams)
  //     const data = await apiFunc(entityName, dynamicParams);
  //     dynamicCache[cacheKey] = data;
  //     return data;
  //   } catch (err) {
  //     console.error("❌ Error in fetchDynamicData:", err);
  //     return null;
  //   }
  // };
  
  
    // Step 1️⃣: Process each row
    for (let index = 0; index < newData.length; index++) {
      const row = newData[index];
      let errors = {};
  
      for (let key in rules) {
        console.log(key)
        const rule = rules[key];
        const value = row[key];
  
        // Required check
        if (rule.required && (value === "" || value === null || value === undefined)) {
          errors[key] = `"${key}" is required but missing/empty`;
          continue;
        }
  
        // Skip type checks if value is missing
        if (value === undefined || value === null || value === ""  && rule.type != "fk") continue;
        
        // Foreign Key check
        if (rule.type === "fk") {
          let list = dropdowns[key] || [];
          console.log(dropdowns)
          console.log(key)
          console.log(rule)
          console.log(row)
          if (row.transactioN_Desc === "Goods at standard rate (default)" && rule.DataSource?.entity === 'sroItemSerialNoDD' ) continue;
          if (row.transactioN_Desc === "Goods at standard rate (default)" && rule.DataSource?.entity === 'sroScheduleNoDD' ) continue;

          // 🔹 If DataSource is 'function', call dynamic fetch
          if (rule.DataSource?.type === "function") {
            const dynamicData = await fetchDynamicData(rule, row);
  
            console.log(dynamicData)
            if (dynamicData && Array.isArray(dynamicData.data)) {
              list = dynamicData.data
              dropdowns[key] = list; // update dropdown cache for this FK
            }
          }
          console.log(list)
          const match = list.find(
            item =>
              String(item.value).trim().toLowerCase() ===
              String(value).trim().toLowerCase()
          );
  
          if (!match) {
            errors[key] = `"${key}" value "${value}" not found in dropdown`;
          } else if (rule.idKey) {
            row[rule.idKey] = match.id;
          }
  
        } else if (rule.type === "number") {
          const numVal = Number(value);
          if (isNaN(numVal)) {
            errors[key] = `"${key}" should be number, but got ${typeof value}`;
          } else {
            row[key] = numVal;
          }
  
        } else if (rule.type === "date") {
          if (!this.isValidDate(value)) {
            const actualType = typeof value;
            errors[key] = `"${key}" should be date, but got ${actualType}`;
          }
  
        } else {
          const actualType = typeof value;
          if (rule.type && actualType !== rule.type) {
            errors[key] = `"${key}" should be ${rule.type}, but got ${actualType}`;
          }
        }
      }
  
      results.push({
        rowIndex: index,
        hasError: Object.keys(errors).length > 0,
        errors,
        ...row
      });
    }
  
    // Step 2️⃣: Check duplicates
    const buildOptions = (fields, keys) => {
      const options = { columnLabels: {}, valueColumns: {} };
      keys.forEach(col => {
        const match = fields.find(f => f.idKey === col || f.field === col);
        if (match) {
          options.columnLabels[col] =
            match.headerText || match.field.replace(/([a-z])([A-Z])/g, "$1 $2");
          if (match.type === "fk" && match.idKey)
            options.valueColumns[col] = match.field;
        }
      });
      return options;
    };
  
    const duplicateResults = this.checkDuplicates(
      results,
      tableData,
      uniqueCombinations,
      mode,
      buildOptions(this.fieldSets[inputType].fields, uniqueCombinations)
    );
  
    // Step 3️⃣: Merge errors
    results = results.map((res, i) => {
      const dupErrors = duplicateResults[i]?.errors || {};
      return {
        ...res,
        errors: { ...res.errors, ...dupErrors },
        hasError: Object.keys({ ...res.errors, ...dupErrors }).length > 0
      };
    });
  
    return results;
  };
  
   
   isValidDate = (value) => {
    // Check if it's already a Date object
    if (value instanceof Date && !isNaN(value)) return true;
  
    // Try to parse if it's a string
    const parsed = new Date(value);
    return !isNaN(parsed.getTime());
  }
  
  

/**
 * Instance method suitable to be used as: this.checkDuplicates(results, tableData, uniqueColumns, mode, options)
 *
 * Accepts newData either as Array<Object> (raw rows) or Array<{ data: Object, errors?:Object, hasError?:boolean }>.
 * Returns Array<{ rowIndex, hasError, errors, data }>.
 */


 checkDuplicates = (newData, tableData, uniqueColumns = [], mode = "with", options = {}) => {
  const ignoreEmpty = options.ignoreEmpty === undefined ? true : Boolean(options.ignoreEmpty);
  const columnLabels = options.columnLabels || {};
  const valueColumns = options.valueColumns || {};

  if (!Array.isArray(newData)) throw new TypeError("newData must be an array");
  if (!Array.isArray(tableData)) throw new TypeError("tableData must be an array");
  if (!Array.isArray(uniqueColumns)) throw new TypeError("uniqueColumns must be an array");

  const normalize = (v) => String(v ?? "").trim().toLowerCase();
  const unwrapRow = (item) => (item && typeof item === "object" && Object.prototype.hasOwnProperty.call(item, "data") ? item.data : item);
  const readRaw = (row, col) => (Object.prototype.hasOwnProperty.call(row, col) ? row[col] : undefined);
  const formatError = (col, val, msg, row) => {
    const label = columnLabels[col] || col;
    const valueCol = valueColumns[col];
    const displayVal = valueCol ? readRaw(row, valueCol) : val;
    return `${label} "${displayVal}" ${msg}`;
  };

  if (uniqueColumns.length === 0) {
    return newData.map((item, idx) => ({
      rowIndex: idx,
      hasError: false,
      errors: {},
      data: unwrapRow(item),
    }));
  }

  const tableCombinationSet = new Set();
  const tablePerColumnMap = new Map();
  if (mode === "without") for (const c of uniqueColumns) tablePerColumnMap.set(c, new Set());

  for (const tRow of tableData) {
    if (mode === "with") {
      const parts = uniqueColumns.map((col) => normalize(readRaw(tRow, col)));
      tableCombinationSet.add(parts.join("||"));
    } else {
      for (const col of uniqueColumns) {
        const val = normalize(readRaw(tRow, col));
        tablePerColumnMap.get(col).add(val);
      }
    }
  }

  const passedCombinationSet = new Set();
  const passedPerColumnMap = new Map();
  if (mode === "without") for (const c of uniqueColumns) passedPerColumnMap.set(c, new Map());

  const results = [];

  for (let i = 0; i < newData.length; i++) {
    const wrapper = newData[i];
    const row = unwrapRow(wrapper);
    const errors = {};

    if (mode === "with") {
      const rawValues = uniqueColumns.map((col) => readRaw(row, col));
      const normalizedParts = rawValues.map((v) => normalize(v));
      const hasEmpty = normalizedParts.some((nv) => nv === "");

      if (hasEmpty && ignoreEmpty) {
        results.push({ rowIndex: i, hasError: false, errors: {}, data: row });
        continue;
      }

      const comboKey = normalizedParts.join("||");

      if (tableCombinationSet.has(comboKey)) {
        for (let j = 0; j < uniqueColumns.length; j++) {
          const col = uniqueColumns[j];
          const val = rawValues[j];
          errors[valueColumns[col] || col] = formatError(col, val, "already exists in table", row);
        }
        results.push({ rowIndex: i, hasError: true, errors, data: row });
        continue;
      }

      if (passedCombinationSet.has(comboKey)) {
        for (let j = 0; j < uniqueColumns.length; j++) {
          const col = uniqueColumns[j];
          const val = rawValues[j];
          errors[valueColumns[col] || col] = formatError(col, val, "is duplicate in  Excel File  ", row);
        }
        results.push({ rowIndex: i, hasError: true, errors, data: row });
        continue;
      }

      passedCombinationSet.add(comboKey);
      results.push({ rowIndex: i, hasError: false, errors: {}, data: row });
    } else {
      let foundDuplicate = false;

      for (const col of uniqueColumns) {
        const rawVal = readRaw(row, col);
        const nVal = normalize(rawVal);

        if (nVal === "" && ignoreEmpty) continue;

        const tableSet = tablePerColumnMap.get(col);
        if (tableSet && tableSet.has(nVal)) {
          errors[valueColumns[col] || col] = formatError(col, rawVal, "already exists in table", row);
          foundDuplicate = true;
          continue;
        }

        const passedMap = passedPerColumnMap.get(col);
        if (passedMap && passedMap.has(nVal)) {
          const firstIdx = passedMap.get(nVal);
          errors[valueColumns[col] || col] = formatError(col, rawVal, `is duplicate in Excel File (conflicts with row ${firstIdx + 2})`, row);
          foundDuplicate = true;
          continue;
        }
      }

      if (foundDuplicate) {
        results.push({ rowIndex: i, hasError: true, errors, data: row });
        continue;
      }

      for (const col of uniqueColumns) {
        const rawVal = readRaw(row, col);
        const nVal = normalize(rawVal);
        if (nVal === "" && ignoreEmpty) continue;
        const passedMap = passedPerColumnMap.get(col);
        if (!passedMap.has(nVal)) passedMap.set(nVal, i);
      }

      results.push({ rowIndex: i, hasError: false, errors: {}, data: row });
    }
  }

  return results;
};

// checkDuplicates = (newData, tableData, uniqueColumns = [], mode = "with", options = {}) => {
//   // Defensive defaults and validation
//   const ignoreEmpty = options.ignoreEmpty === undefined ? true : Boolean(options.ignoreEmpty);
//   if (!Array.isArray(newData)) throw new TypeError("newData must be an array");
//   if (!Array.isArray(tableData)) throw new TypeError("tableData must be an array");
//   if (!Array.isArray(uniqueColumns)) throw new TypeError("uniqueColumns must be an array");

//   // Normalization helper
//   const normalize = (v) => String(v ?? "").trim().toLowerCase();

//   // Helper to determine whether an input item is a validation-result wrapper or a raw row
//   const unwrapRow = (item) => (item && typeof item === "object" && Object.prototype.hasOwnProperty.call(item, "data") ? item.data : item);

//   // Helper to read a column value; if missing treat as undefined
//   const readRaw = (row, col) => (Object.prototype.hasOwnProperty.call(row, col) ? row[col] : undefined);

//   // If no unique columns, nothing to check -> return all rows valid (but keep original data)
//   if (uniqueColumns.length === 0) {
//     return newData.map((item, idx) => ({
//       rowIndex: idx,
//       hasError: false,
//       errors: {},
//       data: unwrapRow(item),
//     }));
//   }

//   // Build table lookups for fast checking
//   const tableCombinationSet = new Set();
//   const tablePerColumnMap = new Map(); // col -> Set(values)
//   if (mode === "without") for (const c of uniqueColumns) tablePerColumnMap.set(c, new Set());

//   for (const tRow of tableData) {
//     if (mode === "with") {
//       const parts = uniqueColumns.map((col) => normalize(readRaw(tRow, col)));
//       tableCombinationSet.add(parts.join("||"));
//     } else {
//       for (const col of uniqueColumns) {
//         const val = normalize(readRaw(tRow, col));
//         tablePerColumnMap.get(col).add(val);
//       }
//     }
//   }

//   // Track previously passed new rows (sequential progressive checking)
//   const passedCombinationSet = new Set();
//   const passedPerColumnMap = new Map(); // col -> Map(normalizedValue -> firstPassedRowIndex)
//   if (mode === "without") for (const c of uniqueColumns) passedPerColumnMap.set(c, new Map());

//   const results = [];

//   for (let i = 0; i < newData.length; i++) {
//     const wrapper = newData[i];
//     const row = unwrapRow(wrapper);
//     const errors = {};

//     if (mode === "with") {
//       const rawValues = uniqueColumns.map((col) => readRaw(row, col));
//       const normalizedParts = rawValues.map((v) => normalize(v));
//       const hasEmpty = normalizedParts.some((nv) => nv === "");

//       // If ignoring empty values and any column is empty, skip duplicate checks for this row
//       if (hasEmpty && ignoreEmpty) {
//         results.push({ rowIndex: i, hasError: false, errors: {}, data: row });
//         continue;
//       }

//       const comboKey = normalizedParts.join("||");

//       // Check against tableData
//       if (tableCombinationSet.has(comboKey)) {
//         const colsStr = uniqueColumns.join("+");
//         const msg = `Combination (${colsStr}) already exists in table`;
//         for (const col of uniqueColumns) errors[col] = msg;
//         results.push({ rowIndex: i, hasError: true, errors, data: row });
//         continue;
//       }

//       // Check against previously-passed new rows
//       if (passedCombinationSet.has(comboKey)) {
//         const colsStr = uniqueColumns.join("+");
//         const msg = `Combination (${colsStr}) is duplicate in new data`;
//         for (const col of uniqueColumns) errors[col] = msg;
//         results.push({ rowIndex: i, hasError: true, errors, data: row });
//         continue;
//       }

//       // Passed: record combination for future rows
//       passedCombinationSet.add(comboKey);
//       results.push({ rowIndex: i, hasError: false, errors: {}, data: row });
//     } else {
//       // mode === "without" : per-column checks (OR). Collect errors per offending column.
//       let foundDuplicate = false;

//       for (const col of uniqueColumns) {
//         const rawVal = readRaw(row, col);
//         const nVal = normalize(rawVal);

//         if (nVal === "" && ignoreEmpty) {
//           // skip this column
//           continue;
//         }

//         const tableSet = tablePerColumnMap.get(col);
//         if (tableSet && tableSet.has(nVal)) {
//           errors[col] = `${col} value "${nVal}" already exists in table`;
//           foundDuplicate = true;
//           continue;
//         }

//         const passedMap = passedPerColumnMap.get(col);
//         if (passedMap && passedMap.has(nVal)) {
//           const firstIdx = passedMap.get(nVal);
//           errors[col] = `${col} value "${nVal}" is duplicate in new data (conflicts with row ${firstIdx + 2})`;
//           foundDuplicate = true;
//           continue;
//         }
//       }

//       if (foundDuplicate) {
//         results.push({ rowIndex: i, hasError: true, errors, data: row });
//         continue;
//       }

//       // Passed: add each column's normalized value into passedPerColumnMap (respect ignoreEmpty)
//       for (const col of uniqueColumns) {
//         const rawVal = readRaw(row, col);
//         const nVal = normalize(rawVal);
//         if (nVal === "" && ignoreEmpty) continue;
//         const passedMap = passedPerColumnMap.get(col);
//         if (!passedMap.has(nVal)) passedMap.set(nVal, i);
//       }

//       results.push({ rowIndex: i, hasError: false, errors: {}, data: row });
//     }
//   }

//   return results;
// };


 generateDataOBJ = (data,inputType) =>{
console.log('generateDataOBJ: ', data)
  switch (inputType) {
    case 'InvoiceOpening':
      return data.map(item => {
      console.log('item: ', item)
      console.log('item: ', item.InvoiceOpeningDate)
        return {
          ExcelObject:item,
          ExcelRowID:item?.ExcelRowID ,
          InvoiceOpeningID:null,	
          InvoiceTypeID:item?.InvoiceTypeID,
          InvoiceID	:null,
          InvoiceOpeningDate:moment(item?.InvoiceOpeningDate).format('DD-MMM-YY'),
          ModuleID:item?.ModuleID,
          AccountID:item?.AccountID,
          PaymentDays:item?.PaymentDays || 0,
          ExcludingTaxAmount:item?.ExcludingTaxAmount || 0,
          TaxAmount:item?.TaxAmount || 0,
          RoundingAmount:item?.RoundingAmount || 0,
          Remarks:item?.Remarks || '-',
          CreationDate:item?.CreationDate || moment(),
          CreatedByUserID:item?.CreatedByUserID || securityService.getLoggedInUserId(),
          UpdationDate:item?.UpdationDate || null,
          UpdatedByUserID:item?.UpdatedByUserID || null,
          IsDeleted:item?.IsDeleted || 0,
          DeletionDate:item?.DeletionDate ||  null,
          DeletedByUserID:item?.DeletedByUserID || null,
          IsApproved:item?.IsApproved	|| null,
          ApprovedByUserID:item?.ApprovedByUserID	|| null,
          ApprovedByDate:item?.ApprovedByDate || null

        }
      })
      
      break;
  
    default:
      break;
  }
}

validateExcel = (data,inputType) =>{
  
  // let validateObject = {
  //   invoiceType:inputProps.invoiceType.value.value ||   'Sale Invoice',
  //   invoiceDate: moment(inputProps.invoiceDate.value).format('YYYY-MM-DD') || '2025-06-30',
  //   sellerNTNCNIC:inputProps.sellerNTNCNIC.value,
  //   sellerBusinessName:inputProps.sellerBusinessName.value,
  //   sellerProvince: inputProps.sellerProvince.value,
  //   sellerAddress: inputProps.sellerAddress.value,
  //   buyerNTNCNIC: inputProps.buyerNTNCNIC.value,
  //   buyerBusinessName: inputProps.buyerBusinessName.value,
  //   buyerProvince: inputProps.buyerProvince.value,
  //   buyerAddress: inputProps.buyerAddress.value,
  //   buyerRegistrationType: inputProps.buyerRegistrationType.value,
  //   invoiceRefNo:inputProps.invoiceRefNo.value ,
  //   scenarioId: props.isTesting == true ? (inputProps.scenarioId.value || '').toUpperCase() : '',
  //   items: [
  //     {
  //       invoiceType:inputProps.invoiceType.value.value || document.getElementById('invoiceType').value,
  //       invoiceDateForGrid:moment(inputProps.invoiceDate.value).format('YYYY-MM-DD') || '2025-06-30',
  //       rowID:isUpdate == true ? inputProps.rowID.value : inputProps.GridDataSource.value.length + 1,
  //       hsCode: inputProps.hsCode.value.id || document.getElementById('hsCodeID').value,
  //       HSCodeDetail: inputProps.hsCode.value.value || document.getElementById('hsCode').value,
  //       productDescription:inputProps.productDescription.value,
  //       rate:inputProps.rate.value.value || document.getElementById('rate').value,
  //       uoM: inputProps.uoM.value.value || document.getElementById('uoM').value,
  //       quantity:Number(inputProps.quantity.value),
  //       totalValues:Number(inputProps.totalValues.value),
  //       valueSalesExcludingST: Number(inputProps.valueSalesExcludingST.value),
  //       fixedNotifiedValueOrRetailPrice: Number(inputProps.fixedNotifiedValueOrRetailPrice.value),
  //       salesTaxApplicable: Number(inputProps.salesTaxApplicable.value),
  //       salesTaxWithheldAtSource: Number(inputProps.salesTaxWithheldAtSource.value),
  //       extraTax: inputProps.extraTax.value || '',
  //       furtherTax: Number(inputProps.furtherTax.value),
  //       sroScheduleNo:inputProps.sroScheduleNo.value.value || '',
  //       fedPayable: Number(inputProps.fedPayable.value),
  //       discount: Number(inputProps.discount.value),
  //       saleType: inputProps.saleType.value.value || '',
  //       sroItemSerialNo: inputProps.sroItemSerialNo.value.value || ''
  //     }
  //   ]
  // }
  
  // console.log("validateObject",validateObject);
}

postData = async (data,inputType) =>{
  console.log(data)
  console.log(inputType)
    // let validataExcelData = validateExcel(data ,inputType)


//   let apiData = this.generateDataOBJ(data,inputType)
//   console.log(apiData)
//  if(apiData.length > 0 ) {
//   return await this.postExcelData(apiData,inputType)
//  }
}
postExcelData = (data,inputType)=>{
  let setApiUrl = (inputType) =>{
    switch (inputType) {
      case 'InvoiceOpening':
        return '/InvoiceOpening/ExcelData/InvoiceOpening'
        break;
    
      default:
        break;
    }
  }
  let apiUrl = setApiUrl(inputType);
  return http.post(`${apiUrl}`,data)
}














//   validateData(rules, newData, dropdowns, tableData, uniqueCombinations = [], mode = "with") {
//   return newData.map((row, index) => {
//     let errors = {};

//     // --- Normal validation ---
//     for (let key in rules) {
//       const rule = rules[key];
//       const value = row[key];

//       // ✅ Required check
//       if (rule.required && (value === "" || value === null || value === undefined)) {
//         errors[key] = `"${key}" is required but missing/empty`;
//         continue;
//       }

//       // ✅ Type checks
//       if (value !== undefined && value !== null) {
//         if (rule.type === "fk") {
//           const list = dropdowns[key] || [];
//           const match = list.find(item => String(item.value).trim().toLowerCase() === String(value).trim().toLowerCase());
//           if (!match) {
//             errors[key] = `"${key}" value "${value}" not found in dropdown`;
//           } else if (rule.idKey) {
//             row[rule.idKey] = match.id;
//           }
//         } else if (rule.type === "number") {
//           const numVal = Number(value);
//           if (isNaN(numVal)) {
//             errors[key] = `"${key}" should be number, but got ${typeof value}`;
//           } else {
//             row[key] = numVal;
//           }
//         } else {
//           const actualType = typeof value;
//           if (rule.type && actualType !== rule.type) {
//             errors[key] = `"${key}" should be ${rule.type}, but got ${actualType}`;
//           }
//         }
//       }
//     }

//     // =======================
//     // --- DUPLICATE CHECKS ---
//     // =======================
//     if (mode === "with") {
//       // 1️⃣ Individual column uniqueness
//       for (let key in rules) {
//         if (rules[key].unique) {
//           // Check existing table
//           if (tableData.some(item => item[key] === row[key])) {
//             errors[key] = `"${key}" value "${row[key]}" already exists in table`;
//           }

//           // Check new data itself
//           if (newData.some((item, i) => i !== index && item[key] === row[key])) {
//             errors[key] = `"${key}" value "${row[key]}" is duplicate in new data"`;
//           }
//         }
//       }

//       // 2️⃣ Combination uniqueness (only if provided)
//       if (Array.isArray(uniqueCombinations) && uniqueCombinations.length > 0) {
//         uniqueCombinations.forEach(combo => {
//           // Ensure combo is an array (handle single column case)
//           const columns = Array.isArray(combo) ? combo : [combo];

//           // Skip if empty
//           if (columns.length === 0) return;

//           // Check in table data
//           if (tableData.some(item => columns.every(c => item[c] === row[c]))) {
//             columns.forEach(c => {
//               errors[c] = `Combination ${columns.join("+")} already exists in table`;
//             });
//           }

//           // Check within new data
//           if (newData.some((item, i) => i !== index && columns.every(c => item[c] === row[c]))) {
//             columns.forEach(c => {
//               errors[c] = `Combination ${columns.join("+")} is duplicate in new data`;
//             });
//           }
//         });
//       }
//     }

//     // ✅ Final return
//     return {
//       rowIndex: index,
//       hasError: Object.keys(errors).length === 0,
//       errors,
//       data: row
//     };
//   });
// }


}

export default new ImportExcelService();




// const rules = {
//   InvoiceTypeName: { required: false, type: "fk", idKey: "InvoiceTypeID" }, // dropdown maps to InvoiceTypeID

//   InvoiceOpeningDate: { required: false, type: "date" },                    // must be valid date

//   ModuleName: { required: false, type: "fk", idKey: "ModuleID" },           // dropdown maps to ModuleID
//   AccountName: { required: false, type: "fk", idKey: "AccountID" },         // dropdown maps to AccountID

//   PaymentDays: { required: false, type: "number" },                        // optional number
//   ExcludingTaxAmount: { required: false, type: "number" },                  // must be number
//   TaxAmount: { required: false, type: "number" },                          // optional number
//   RoundingAmount: { required: false, type: "number" },                     // optional number
//   Remarks: { required: false, type: "string" }                             // optional string
// };



// let das = [
//   {
//     rowIndex: 0,
//     hasError: true,
//     errors: {},
//     data: {
//       InvoiceTypeID: "Sales",
//       InvoiceID: "INV-001",
//       InvoiceOpeningDate: "2023-03-01",
//       ModuleID: "Finance",
//       AccountID: "Customer A",
//       PaymentDays: 30,
//       ExcludingTaxAmount: 100000,
//       TaxAmount: 17000.25,
//       RoundingAmount: 0,
//       Remarks: "REMARKS",
//       // these were mapped by FK rules 👇
//       InvoiceTypeID: 1,
//       InvoiceID: 1,
//       ModuleID: 5,
//       AccountID: 22
//     }
//   }
// ]




// const dropdowns = {
//   InvoiceTypeID: [
//     { id: 1, value: "Sales" },
//     { id: 2, value: "Purchase" }
//   ],
//   InvoiceID: [
//     { id: 1, value: "INV-001" },
//     { id: 2, value: "INV-002" }
//   ],
//   ModuleID: [
//     { id: 5, value: "Finance" },
//     { id: 6, value: "Inventory" }
//   ],
//   AccountID: [
//     { id: 22, value: "Customer A" },
//     { id: 23, value: "Customer B" }
//   ]
// };


// console.log(validateData(rules, newData, dropdowns, tableData, [["ProductName", "Age"]], "both"));

// function validateData(rules, newData, dropdowns, tableData, uniqueCombinations = [], mode = "both") {
//   return newData.map((row, index) => {
//     let errors = {};

//     // --- Normal validation ---
//     for (let key in rules) {
//       const rule = rules[key];
//       const value = row[key];

//       if (rule.required && (value === "" || value === null || value === undefined)) {
//         errors[key] = `"${key}" is required but missing/empty`;
//         continue;
//       }

//       if (value !== undefined && value !== null && value !== "") {
//         if (rule.type === "fk") {
//           const list = dropdowns[key] || [];
//           const match = list.find(item => item.value === value);
//           if (!match) {
//             errors[key] = `"${key}" value "${value}" not found in dropdown`;
//           } else if (rule.idKey) {
//             row[rule.idKey] = match.id;
//           }
//         } else if (rule.type === "number") {
//           let numVal = Number(value);
//           if (isNaN(numVal)) {
//             errors[key] = `"${key}" should be number, but got ${typeof value}`;
//           } else {
//             row[key] = numVal;
//           }
//         } else {
//           const actualType = typeof value;
//           if (rule.type && actualType !== rule.type) {
//             errors[key] = `"${key}" should be ${rule.type}, but got ${actualType}`;
//           }
//         }
//       }
//     }

//     // --- Duplicate Checks ---
  
//     // Mode: "both" → check both

//     if (mode === "individual" || mode === "both") {
//       // 1️⃣ Single column uniqueness
//       for (let key in rules) {
//         if (rules[key].unique) {
//           // check against tableData
//           if (tableData.some(item => item[key] === row[key])) {
//             errors[key] = `"${key}" value "${row[key]}" already exists in table`;
//           }

//           // check inside newData itself (excluding current row)
//           if (newData.some((item, i) => i !== index && item[key] === row[key])) {
//             errors[key] = `"${key}" value "${row[key]}" is duplicate in new data`;
//           }
//         }
//       }
//     }

//     if (mode === "combination" || mode === "both") {
//       // 2️⃣ Combination uniqueness
//       uniqueCombinations.forEach(combo => {
//         const comboKey = combo.map(c => row[c]).join("|");

//         // check in tableData
//         if (tableData.some(item => combo.every(c => item[c] === row[c]))) {
//           combo.forEach(c => {
//             errors[c] = `Combination ${combo.join("+")} already exists in table`;
//           });
//         }

//         // check in newData itself
//         if (newData.some((item, i) => i !== index && combo.every(c => item[c] === row[c]))) {
//           combo.forEach(c => {
//             errors[c] = `Combination ${combo.join("+")} is duplicate in new data`;
//           });
//         }
//       });
//     }

//     return {
//       rowIndex: index,
//       hasError: Object.keys(errors).length === 0,
//       errors,
//       data: row
//     };
//   });
// }



// function validateDuplicates(data, tableData, fields, mode = "combination") {
//   // mode: "combination" | "individual"
//   const allData = [...tableData, ...data]; // merge both arrays
  
//   return data.map((row, index) => {
//     let errors = {};
    
//     if (mode === "combination") {
//       // create key by joining values of selected fields
//       const key = fields.map(f => row[f]).join("|");

//       const duplicates = allData.filter(r => 
//         fields.map(f => r[f]).join("|") === key
//       );

//       if (duplicates.length > 1) {
//         fields.forEach(f => {
//           errors[f] = "Duplicate combination found";
//         });
//       }
//     } else if (mode === "individual") {
//       // check each field individually
//       fields.forEach(f => {
//         const duplicates = allData.filter(r => r[f] === row[f]);
//         if (duplicates.length > 1) {
//           errors[f] = "Duplicate value found";
//         }
//       });
//     }

//     return {
//       ...row,
//       hasError: Object.keys(errors).length === 0,
//       rowIndex: index,
//       errors
//     };
//   });
// }








// const result = validateAndCheckDuplicates(
//   rules,
//   newData,
//   { buyer: buyerList },
//   tableData,
//   [["productName", "age"]]
// );

// console.log(result);

// function validateAndCheckDuplicates(rules, newData, dropdowns, tableData, uniqueCombinations = []) {
//   return newData.map((row, index) => {
//     let errors = {};

//     // --- Normal validation ---
//     for (let key in rules) {
//       const rule = rules[key];
//       const value = row[key];

//       if (rule.required && (value === "" || value === null || value === undefined)) {
//         errors[key] = `"${key}" is required but missing/empty`;
//         continue;
//       }

//       if (value !== undefined && value !== null && value !== "") {
//         if (rule.type === "fk") {
//           const list = dropdowns[key] || [];
//           const match = list.find(item => item.value === value);
//           if (!match) {
//             errors[key] = `"${key}" value "${value}" not found in dropdown`;
//           } else if (rule.idKey) {
//             row[rule.idKey] = match.id;
//           }


//         } else if (rule.type === "number") {
//           let numVal = Number(value);
//           if (isNaN(numVal)) {
//             errors[key] = `"${key}" should be number, but got ${typeof value}`;
//           } else {
//             row[key] = numVal;
//           }
//         } else {
//           const actualType = typeof value;
//           if (rule.type && actualType !== rule.type) {
//             errors[key] = `"${key}" should be ${rule.type}, but got ${actualType}`;
//           }
//         }
//       }
//     }

//     // --- Duplicate Checks ---

//     // 1️⃣ Single column uniqueness
//     for (let key in rules) {
//       if (rules[key].unique) {
//         // check against tableData
//         if (tableData.some(item => item[key] === row[key])) {
//           errors[key] = `"${key}" value "${row[key]}" already exists in table`;
//         }

//         // check inside newData itself (excluding current row)
//         if (
//           newData.some((item, i) => i !== index && item[key] === row[key])
//         ) {
//           errors[key] = `"${key}" value "${row[key]}" is duplicate in new data`;
//         }
//       }
//     }

//     // 2️⃣ Combination uniqueness
//     uniqueCombinations.forEach(combo => {
//       const comboKey = combo.map(c => row[c]).join("|");

//       // check in tableData
//       if (
//         tableData.some(item =>
//           combo.every(c => item[c] === row[c])
//         )
//       ) {
//         combo.forEach(c => {
//           errors[c] = `Combination ${combo.join("+")} already exists in table`;
//         });
//       }

//       // check in newData itself
//       if (
//         newData.some((item, i) =>
//           i !== index && combo.every(c => item[c] === row[c])
//         )
//       ) {
//         combo.forEach(c => {
//           errors[c] = `Combination ${combo.join("+")} is duplicate in new data`;
//         });
//       }
//     });

//     return {
//       rowIndex: index,
//       hasError: Object.keys(errors).length === 0,
//       errors,
//       data: row
//     };
//   });
// }


// const tableData = [
//   { productName: "Shirt", age: 25, buyer: "Ali", buyerId: 1 },
//   { productName: "Pant", age: 30, buyer: "Sara", buyerId: 2 }
// ];


// const newDatas = [
//   { productName: "Shirt", age: 25, buyer: "Ali" },   // ❌ duplicate with table
//   { productName: "Pant", age: 40, buyer: "Sara" },   // ✅ unique
//   { productName: "Shirt", age: 25, buyer: "Ali" },   // ❌ duplicate inside newData
//   { productName: "Shirt", age: 22, buyer: "Sara" }   // ✅ unique
// ];
